const DrawerContainerStyles = (theme) => ({
  holidayGridContainer: {
    maxWidth: "68%",
    padding: 0,
    "& $gridHead": {
      minHeight: 32,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    },
    "& $dataGrid": {
      maxHeight: "65%",
      height: "65%"
    }
  },
  holidayGrid: {
    margin: "20 0 60 0",
    height: 300
  },
  statusBar: {
    margin: "unset",
    padding: 6,
    border: `1px solid ${theme.AppBGColor}`,
  },
  paperAnchor: {
    position: "absolute",
    width: 380,
    zIndex: 100,
    backgroundColor: theme.ModalBGColor,
  },
});

export default DrawerContainerStyles;
